import { useEffect } from 'react';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'elevenlabs-convai': {
        'agent-id': string;
        style?: React.CSSProperties;
      };
    }
  }
}

export default function ElevenLabsWidget() {
  useEffect(() => {
    const checkWidget = setInterval(() => {
      const widget = document.querySelector('elevenlabs-convai') as HTMLElement;
      if (widget) {
        widget.style.setProperty('--avatar-background', 'linear-gradient(135deg, #14b8a6, #10b981)');
        widget.style.setProperty('--widget-background', 'rgba(13, 148, 136, 0.15)');
        widget.style.setProperty('--widget-border', '1px solid rgba(20, 184, 166, 0.3)');
        widget.style.setProperty('--button-background', 'linear-gradient(135deg, #14b8a6, #10b981)');
        widget.style.setProperty('--button-hover-background', 'linear-gradient(135deg, #0d9488, #059669)');
        widget.style.setProperty('--primary-color', '#14b8a6');
        widget.style.setProperty('--secondary-color', '#10b981');
        clearInterval(checkWidget);
      }
    }, 100);

    return () => clearInterval(checkWidget);
  }, []);

  return (
    <elevenlabs-convai
      agent-id="agent_9501kegpx9enejvbysk85y31f6z5"
      style={{
        '--widget-background': 'rgba(13, 148, 136, 0.15)',
        '--widget-border': '1px solid rgba(20, 184, 166, 0.3)',
      } as React.CSSProperties}
    />
  );
}
